import React from 'react';
import StockComparison from '../components/comparison/StockComparison';
import { SEOMeta, getToolSEOMeta } from '../components/SEOMeta';

export function StockComparisonPage() {
  const seoMeta = getToolSEOMeta('compare');

  return <div className="min-h-screen bg-theme-primary p-4 md:p-6">
    <SEOMeta
      title={seoMeta.title}
      description={seoMeta.description}
      keywords={seoMeta.keywords}
    />
    <StockComparison />
  </div>;
}